import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import NeighborhoodExplorer from "@/pages/NeighborhoodExplorer";

export const Route = createFileRoute("/neighborhood-explorer")({
  head: () => seoHead("/neighborhood-explorer"),
  component: NeighborhoodExplorer,
});
